export default __webpack_public_path__ + "static/media/to.6678aeed.svg";